import React, { useEffect, useState } from "react";
import { useDeleteLoanAppSettlementSheetMutation } from "../../../../../../services/RTKQuery/loanAppSettlementSheet";

export const DeleteTest = ({ loanUuid, itemUuid, setStatusInParent }) => {
  const statusUnknown = "❓Unknown Status";
  const statusPass = "✅ Pass";
  const statusFail = "❌ Fail";

  const [statusReadSingle, setStatus] = useState(statusUnknown);
  const [detailsText, setDetailsText] = useState("statusUnknown");

  const [deleteLoanAppSettlementSheetTrigger] =
    useDeleteLoanAppSettlementSheetMutation();
  useEffect(() => {
    deleteLoanAppSettlementSheetTrigger({
      loan_uuid: loanUuid,
      item_uuid: itemUuid
    })
      .unwrap()
      .then(fulfilled => {
        //
        if (
          fulfilled?.data?.uuid === itemUuid &&
          fulfilled?.data?.deleted === true
        ) {
          setStatus(statusPass);
          setDetailsText(`: Soft deleted item: ${itemUuid}`);
          setStatusInParent("Pass");
        } else {
          console.error("delete fulfilled: ", fulfilled);
          setStatus(statusFail);
          setDetailsText(`: Did NOT delete item: ${itemUuid}`);
          setStatusInParent("Fail");
        }
      })
      .catch(error => {
        console.error("Fail: useDeleteLoanAppSettlementSheetMutation", error);
        setStatus(statusFail);
        setStatusInParent("Fail");
      });
  }, [
    deleteLoanAppSettlementSheetTrigger,
    itemUuid,
    loanUuid,
    setStatusInParent
  ]);

  return (
    <>
      <b>{statusReadSingle}</b>
      <small>{detailsText}</small>
    </>
  );
};
